export default function getResource(label) {
    const resources = {
        top: 'Top',
        details: 'Details',
        similar: 'Similar',
        qAndA: 'Q&A',
        reviews: 'Reviews',
        navLabel: 'Product page navigation'
    };

    return resources[label];
}
